export function SectionTitle({ eyebrow, title, subtitle, center }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-10`}>
      {eyebrow && (
        <div className={`text-xs font-semibold tracking-[0.3em] uppercase text-[#8A6320] mb-3 ${center ? "" : ""}`}>{eyebrow}</div>
      )}
      <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#0B2E63]">{title}</h2>
      <div className={`gold-rule w-24 mt-4 ${center ? "mx-auto" : ""}`} />
      {subtitle && <p className="mt-4 text-[#5A6270] leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function PageHeader({ title, subtitle }) {
  return (
    <section className="hero-grain text-white" data-testid="page-header">
      <div className="max-w-7xl mx-auto px-4 py-16 sm:py-20">
        <div className="text-xs font-semibold tracking-[0.35em] uppercase text-[#D4AF37] mb-3">HCABA · Jabalpur</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold">{title}</h1>
        <div className="gold-rule w-28 mt-5" />
        {subtitle && <p className="mt-5 max-w-2xl text-[#e6d9bd] font-garamond text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}
